import React, { useState } from 'react';
import { Box, Flex, Text, Grid, Button, Input } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { ProductCard, SectionHeader } from '../components/ui/Cards';
import { useApp } from '../hooks/useApp';

const CATEGORIES = ['All', 'Smartphones', 'Audio', 'Laptops', 'Smartwatches', 'Cameras', 'Monitors'];

export default function DealsPage() {
  const { products } = useApp();
  const [search, setSearch] = useState('');
  const [activeBadge, setActiveBadge] = useState('All');

  const filtered = products.filter(p => {
    const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.desc?.toLowerCase().includes(search.toLowerCase());
    const matchBadge = activeBadge === 'All' ||
      (activeBadge === 'My Picks' && p.badge === 'pick') ||
      (activeBadge === 'Hot Deals' && p.badge === 'hot') ||
      (activeBadge === 'New' && p.badge === 'new');
    return matchSearch && matchBadge;
  });

  return (
    <Box pt="100px" pb="90px" px="5%">
      <Flex align="flex-end" justify="space-between" flexWrap="wrap" gap={4} mb={5}>
        <SectionHeader
          label="Affiliate Picks"
          title='Best <em style="font-style:normal;color:#00c3ff">Deals & Gear</em>'
          desc="Every product personally tested. Affiliate links support the channel at no extra cost to you."
        />
        <Box
          bg="rgba(0,195,255,0.06)"
          border="1px solid rgba(0,195,255,0.18)"
          borderRadius="8px"
          px={3}
          py={2}
          fontSize="0.75rem"
          color="#7878a0"
        >
          🔗 Affiliate Disclosure
        </Box>
      </Flex>

      {/* Filters */}
      <Flex align="center" justify="space-between" flexWrap="wrap" gap={4} mb={8}>
        <Flex gap={2} flexWrap="wrap">
          {['All', 'My Picks', 'Hot Deals', 'New'].map(f => (
            <Button
              key={f}
              size="sm"
              px={4}
              py={2}
              borderRadius="full"
              fontSize="0.82rem"
              fontWeight={600}
              bg={activeBadge === f ? '#00c3ff' : 'transparent'}
              color={activeBadge === f ? '#000' : '#6b7fa0'}
              border={activeBadge === f ? 'none' : '1px solid rgba(0,195,255,0.15)'}
              _hover={{ bg: activeBadge === f ? '#00c3ff' : 'rgba(0,195,255,0.1)', color: activeBadge === f ? '#000' : '#00c3ff' }}
              onClick={() => setActiveBadge(f)}
            >
              {f}
            </Button>
          ))}
        </Flex>
        <Flex
          bg="#0f0f14"
          border="1px solid rgba(255,255,255,0.07)"
          borderRadius="8px"
          align="center"
          px={3}
          gap={2}
          w={{ base: '100%', sm: '260px' }}
        >
          <SearchIcon color="#7878a0" w={3.5} h={3.5} />
          <Input
            variant="unstyled"
            placeholder="Search products..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            color="#f0f0f5"
            _placeholder={{ color: '#7878a0' }}
            fontSize="0.88rem"
            py={2.5}
          />
        </Flex>
      </Flex>

      {filtered.length > 0 ? (
        <Grid templateColumns={{ base: '1fr', sm: 'repeat(2,1fr)', lg: 'repeat(3,1fr)' }} gap={5.5}>
          {filtered.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </Grid>
      ) : (
        <Box textAlign="center" py={20} color="#7878a0">
          <Text fontSize="3rem" mb={3}>🛒</Text>
          <Text fontSize="1rem">No products found.</Text>
        </Box>
      )}

      {/* Disclaimer */}
      <Box
        mt={12}
        p={5}
        bg="#0f0f14"
        border="1px solid rgba(255,255,255,0.07)"
        borderRadius="12px"
        fontSize="0.82rem"
        color="#7878a0"
        lineHeight={1.8}
      >
        <Text fontWeight={600} color="#f0f0f5" mb={1}>Affiliate Disclosure</Text>
        TechBheekaran participates in affiliate programs. When you click on product links and make a purchase, we may earn a commission at no additional cost to you. All products are personally tested and recommended based on their genuine merit.
      </Box>
    </Box>
  );
}
